import React from "react";
import { inr } from "@/lib/ownerApi";

const Col = ({ title, v, tid, note }) => (
  <div className="rounded-xl border border-stone-200 bg-white p-3 space-y-1" data-testid={tid}>
    <div className="text-xs font-semibold uppercase tracking-wide text-stone-500">{title}</div>
    <div className="text-sm">Students <b>{v.students}</b></div>
    <div className="text-sm">Fees <b>{inr(v.fees || 0)}</b></div>
    <div className="text-sm">Collected <b className="text-emerald-800">{inr(v.collected || 0)}</b></div>
    {v.balance !== undefined && <div className="text-sm">Balance <b className="text-amber-800">{inr(v.balance || 0)}</b></div>}
    {note && <p className="text-[11px] text-stone-500 pt-1">{note}</p>}
  </div>
);

export default function ReconHeadline({ h, problems }) {
  const dc = h.excel_rows.collected - (h.excel_dashboard.collected || 0);
  return (
    <section className="space-y-3" data-testid="recon-headline">
      <h3 className="font-bold text-stone-900">Before vs after: where the totals come from</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Col title="Excel DASHBOARD sheet" v={h.excel_dashboard} tid="recon-col-dashboard" note="Numbers your Excel shows today." />
        <Col title="Excel student rows (re-added)" v={h.excel_rows} tid="recon-col-rows" note="Every student row added up by the system, same batches as the DASHBOARD." />
        <Col title="Excel incl. Degree block" v={h.excel_rows_all} tid="recon-col-all" note="Degree (fy/sy/ty) sits in the college sheet but is not in your DASHBOARD." />
        <Col title="Website today" v={h.website} tid="recon-col-website" note={`Only fees generated in the app and receipts approved in the app. ${h.website.test_students_excluded} test students excluded.`} />
      </div>
      <ul className="text-sm text-stone-700 list-disc pl-5 space-y-1" data-testid="recon-explain">
        <li>Fees match exactly: student rows {inr(h.excel_rows.fees)} = DASHBOARD {inr(h.excel_dashboard.fees || 0)}.</li>
        <li>Collected differs by {inr(dc)}: some Excel monthly-total formulas skip student rows (see the ● notes in the batch table, e.g. 1st–2nd).</li>
        <li>Student count: DASHBOARD shows {h.excel_dashboard.students}, rows give {h.excel_rows.students}. Several COUNTA ranges skip rows, and 9th/10th counts are swapped (9th has 30 students, 10th has 12).</li>
        <li>The website shows only {inr(h.website.fees)} fees and {inr(h.website.collected)} collected because the app holds only the monthly charges created inside it, no lump-sum fees for 8th/9th/10th/School/College, and only receipts approved in the app. June–September cash is in Excel only — that is why the Excel history must be imported, not replaced.</li>
      </ul>
      {problems?.length > 0 && <p className="text-sm text-red-700">Problems: {problems.join("; ")}</p>}
    </section>
  );
}
